import { Component, type ErrorInfo, type ReactNode } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import { isRecoverableChunkError, recoverFromChunkLoadFailure } from '@/lib/chunkReloadRecovery'

type Props = {
  children: ReactNode
}

type State = {
  error: Error | null
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, _errorInfo: ErrorInfo) {
    if (
      isRecoverableChunkError(error, window.location.origin) &&
      recoverFromChunkLoadFailure('react-error-boundary', error.message)
    ) {
      return
    }
  }

  private handleReload = () => {
    window.location.reload()
  }

  render() {
    if (!this.state.error) return this.props.children

    return (
      <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
        <div className="card max-w-sm w-full text-center flex flex-col items-center gap-3">
          <AlertTriangle size={32} className="text-amber-500" />
          <div>
            <h1 className="text-base font-bold text-neutral-800">画面の復帰に失敗しました</h1>
            <p className="text-sm text-neutral-500 mt-1">
              通信状態や更新直後の読み込みで一時的に表示できませんでした。
            </p>
          </div>
          <button
            type="button"
            onClick={this.handleReload}
            className="btn-primary inline-flex items-center gap-2"
          >
            <RefreshCw size={16} />
            再読み込み
          </button>
        </div>
      </div>
    )
  }
}
